exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LayerCard {\n    clear: both;\n    z-index: 2000!important;\n    margin: 8px 4px 8px 4px;\n}\n\n.LayerCard-header {\n    height: 56px;\n    padding-left: 14px;\n    padding-right: 8px;\n    margin-right: -8px;\n    font-size: 10px;\n}\n\n.LayerCard-header span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/layers/layers/LayerCard.css
// module id = 1019
// module chunks = 0